import { render, staticRenderFns } from "./SettingsNotificationMailingBccEmail.vue?vue&type=template&id=755f4601&"
import script from "./SettingsNotificationMailingBccEmail.vue?vue&type=script&lang=ts&"
export * from "./SettingsNotificationMailingBccEmail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports